import type { HttpClient } from '../client';
import { toQuery } from '../client';
import type { AmapWebConfig, GeoBackfillRow, GeocodeQuery, GeoPoint } from '../types/geo';

const GEO = '/sys/geo';

/**
 * 地图能力（机构/医共体/运营仓/仓库 的地址落经纬度）。
 * 高德 Key 只在服务端配置；前端只用 Web 端 Key 做地图选点。
 */
export function createGeoApi(http: HttpClient) {
  return {
    /** 前端地图配置（Web 端 Key + 安全密钥）；未配置时 enabled=false。 */
    amapConfig(): Promise<AmapWebConfig> {
      return http.request<AmapWebConfig>({ path: `${GEO}/amap` });
    },

    /** 地址 → 坐标（服务端代理高德 Web 服务，避免暴露 Web 服务 Key）。 */
    geocode(query: GeocodeQuery): Promise<GeoPoint> {
      return http.request<GeoPoint>({ path: `${GEO}/geocode`, query: toQuery(query) });
    },

    /** 存量回填（有地址缺坐标的机构/医共体/运营仓/仓库，每次每表最多 100 条）。 */
    backfill(): Promise<GeoBackfillRow[]> {
      return http.request<GeoBackfillRow[]>({ path: `${GEO}/backfill`, method: 'POST' });
    }
  };
}

export type GeoApi = ReturnType<typeof createGeoApi>;
